import { ISvgComponent } from '../../svg.models';
import * as S from '../svg.style';

export const ChevronRightBtn: React.FC<ISvgComponent> = ({
  color,
  height,
  width,
  shrinkable,
  ...rest
}) => (
  <S.Svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    height={height}
    width={width}
    viewBox="0 0 9.136 9.136"
    shrinkable={shrinkable}
    {...rest}
  >
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="m2.659.75 3.818 3.818-3.818 3.818"
    />
  </S.Svg>
);

